import React from 'react';

export const Loading = (
  <div className="container flex justify-center w-full h-full absolute inset-0 bg-opacity-25 bg-gray-500">
    <div className="flex space-x-1 text-sm text-gray-700 pt-10">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 100">
        <circle fill="#004aad" stroke="#004aad" stroke-width="1" r="2" cx="90" cy="50">
          <animate attributeName="opacity" calcMode="spline" dur="3" values="1;0;1;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="-.4">
          </animate>
        </circle>
        <circle fill="#004aad" stroke="#004aad" stroke-width="1" r="2" cx="100" cy="50">
          <animate attributeName="opacity" calcMode="spline" dur="3" values="1;0;1;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="-.2">
          </animate>
        </circle>
        <circle fill="#004aad" stroke="#004aad" stroke-width="1" r="2" cx="110" cy="50">
          <animate attributeName="opacity" calcMode="spline" dur="3" values="1;0;1;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="0">
          </animate>
        </circle>
      </svg>
      {/* <div>Loading ...</div> */}
    </div>
  </div>
);
